import React from "react";
import Mission from "../../components/UserComponents/about/Mission";
import AboutExplore from "../../components/UserComponents/about/AboutExplore";
import AboutOutService from "../../components/UserComponents/about/aboutServiceData";
import TextImageBanner from "../../components/common/TextImageBanner";
import image from "../../Assets/Home/MainHome/home3.png"
const About = () => {
  return (
    <div className="bg-[#fafafa]">
      <TextImageBanner
        label={"About"}
        bgImage={[
          `${image}`,
          `${image}`,
          `${image}`,
        ]}
      />
      <Mission />
      <AboutExplore />
      <AboutOutService />
    </div>
  );
};

export default About;
